import React, { Component } from 'react';
import Clients from '../../components/css/dark/img/theme-images/clients.svg';
import ReportPopup from '../../components/Admin/ReportPopup';
import PayoutReportPopup from '../../components/Admin/PayoutReport';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import $ from 'jquery';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";

class Reports extends Component {
    constructor(props) {
        super(props);
        try {
            this.state = {
                // users: null,
                DisshowPopup: false,
                PayoutReportPopup: false
            };
        }
        catch (error) { }
    }
    toggleDisPopup() {
        if (this.state.DisshowPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    DisshowPopup: !this.state.DisshowPopup,
                });
            }, 500)
        } else {
            this.setState({
                DisshowPopup: !this.state.DisshowPopup,
            });
        }
    }
    togglePayoutPopup() {
        if (this.state.PayoutReportPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    PayoutReportPopup: !this.state.PayoutReportPopup,
                });
            }, 500)
        } else {
            this.setState({
                PayoutReportPopup: !this.state.PayoutReportPopup,
            });
        }
    }
    componentDidMount() {
        $(".analytics-menu").click(e => {
            if ($('.collapseButton').hasClass("active")) {
                this.handleCollapse();
                $('.sidebar-submenu').show();
                $('body').toggleClass('sub-menu-active');
            }
        });
        setTimeout(function () {
            const hasScrollbar = document.body.scrollHeight > window.innerHeight;
            if (!hasScrollbar) {
                $('body').addClass('hide-scroller');
            }
        }, 300);
    }
    componentWillUnmount() {
        $('body').removeClass('hide-scroller');
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $(".collapseButton").removeClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 313 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".tool-section").animate({
                marginLeft: 133 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    render() {
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'wholesaler') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div>
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar />
                <div className="tool-section report">

                    <h2>Reports <span className="beta-link"><span className="beta">Beta</span></span></h2>

                    <ul>
                        <li onClick={this.toggleDisPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Commission <br />Payout Report<span className="arrow">&nbsp;</span></div></li>
                        <li onClick={this.togglePayoutPopup.bind(this)}><div className="manage-content"><img src={Clients} alt="" />Admin Payout <br />Report<span className="arrow">&nbsp;</span></div></li>
                    </ul>
                    {
                        this.state.DisshowPopup ?
                            <ReportPopup text='Commission Payout Report' closePopup={this.toggleDisPopup.bind(this)} /> : null
                    }
                    {
                        this.state.PayoutReportPopup ?
                            <PayoutReportPopup text='Admin Payout Report' closePopup={this.togglePayoutPopup.bind(this)} /> : null
                    }
                </div>
            </div>
        )

    }

}
export default Reports;